// extracted by mini-css-extract-plugin
module.exports = {"c-SettingsNavigation__left_nav_panel":"SettingsNavigation_c-SettingsNavigation__left_nav_panel__3cQxm"};